import React from 'react';
import { Row, Col, Form, Input, Select, DatePicker, InputNumber } from 'antd';
import ImageUploadField from './ImageUploadField';

/**
 * 司机基本信息表单属性
 */
interface DriverBasicInfoFormProps {
  isViewMode: boolean;
  fileLists: any;
  handleUploadChange: (info: any, name: string) => void;
}

/**
 * 司机基本信息表单组件
 */
const DriverBasicInfoForm: React.FC<DriverBasicInfoFormProps> = ({
  isViewMode,
  fileLists,
  handleUploadChange,
}) => {



  return (
    <>
      <Row gutter={24}>
         <Col span={6}>
          <Form.Item name="name" label="司机姓名" rules={[{ required: true }]}>
            <Input />
          </Form.Item>
        </Col>
       
        <Col span={6}>
          <Form.Item name="gender" label="性别">
            <Select options={[{ value: '男', label: '男' }, { value: '女', label: '女' }]} />
          </Form.Item>
        </Col>
         
        <Col span={6}>
          <Form.Item label="出生日期">
            <Row>
              <Col span={16}>
                <Form.Item name="birthday" noStyle>
                  <DatePicker style={{ width: '100%' }} />
                </Form.Item>
              </Col>
              {/* <Col span={8} style={{ textAlign: 'center' }}>
                <Form.Item name="xxyyBirthDateReferenceOnly" noStyle valuePropName="checked">
                  <Switch unCheckedChildren="仅参考" checkedChildren="仅参考" />
                </Form.Item>
              </Col> */}
            </Row>
          </Form.Item>
        </Col>
        
        <Col span={6}>
          <Form.Item name="placeOfOrigin" label="籍贯">
            <Input />
          </Form.Item>
        </Col>
        <Col span={6}>
          <Form.Item name="phone" label="联系电话">
            <Input />
          </Form.Item>
        </Col>
        <Col span={6}>
          <Form.Item name="degrees" label="学历">
            <Input />
          </Form.Item>
        </Col>
        <Col span={6}>
          <Form.Item name="maritalStat" label="婚姻情况">
            <Select options={[{ value: '已婚', label: '已婚' }, { value: '未婚', label: '未婚' }]} />
          </Form.Item>
        </Col>
        <Col span={6}>
          <Form.Item name="fertilityStat" label="生育状况">
            <Select options={[{ value: '已育', label: '已育' }, { value: '未育', label: '未育' }]} />
          </Form.Item>
        </Col>
        <Col span={6}>
          <Form.Item name="drivingAge" label="驾龄">
            <InputNumber addonAfter="年" style={{ width: '100%' }} />
          </Form.Item>
        </Col>
        <Col span={6}>
          <Form.Item name="assistDrivingExp" label="是否有辅助驾驶设备使用经验">
            <Select options={[{ value: '是', label: '是' }, { value: '否', label: '否' }]} />
          </Form.Item>
        </Col>
        <Col span={6}>
          <Form.Item name="lastWorkDate" label="最近一次工作日期">
            <DatePicker placeholder='' style={{ width: '100%' }}  disabled={true}/>
          </Form.Item>
        </Col>
      </Row>

      <Row gutter={24}>
        <Col span={6}>
          <ImageUploadField
            name="idCard"
            label="身份证"
            maxCount={2}
            fileList={fileLists.idCard || []}
            isViewMode={isViewMode}
            onChange={handleUploadChange}
          />
        </Col>
        <Col span={6}>
          <ImageUploadField
            name="driverLicense"
            label="驾驶证"
            maxCount={2}
            fileList={fileLists.driverLicense || []}
            isViewMode={isViewMode}
            onChange={handleUploadChange}
          />
        </Col>
        <Col span={6}>
          <ImageUploadField
            name="photo"
            label="照片"
            maxCount={1}
            fileList={fileLists.photo || []}
            isViewMode={isViewMode}
            onChange={handleUploadChange}
          />
        </Col>
      </Row>

      <Row gutter={24}>
        <Col span={6}>
          <Form.Item name="permResidence" label="常居住地">
            <Input />
          </Form.Item>
        </Col>
        <Col span={6}>
          <Form.Item name="familyEconStat" label="家庭经济状况">
            <Input />
          </Form.Item>
        </Col>
        <Col span={6}>
          <Form.Item name="personality" label="性格">
            <Input />
          </Form.Item>
        </Col>
        <Col span={6}>
          <Form.Item name="safetyAware" label="安全意识">
            <Input />
          </Form.Item>
        </Col>
      </Row>
    </>
  );
};

export default DriverBasicInfoForm;
